import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_CARD_REPLACEMENT_REQUESTS_LIST: 'cardReplacementRequest/FETCH_CARD_REPLACEMENT_REQUESTS_LIST',
    FETCH_CARD_REPLACEMENT_REQUEST: 'cardReplacementRequest/FETCH_CARD_REPLACEMENT_REQUEST',
    CREATE_CARD_REPLACEMENT_REQUEST: 'cardReplacementRequest/CREATE_CARD_REPLACEMENT_REQUEST',
    APPROVE_CARD_REPLACEMENT_REQUEST: 'cardReplacementRequest/APPROVE_CARD_REPLACEMENT_REQUEST',
    CLEAR_MUTATION_FLAGS: 'cardReplacementRequest/CLEAR_MUTATION_FLAGS',
    RESET: 'cardReplacementRequest/RESET',
};
const apiUrl = 'api/card-replacement-requests';
const initialState = {
    loading: false,
    loadingEntity: false,
    errorMessage: null,
    entities: [],
    entity: null,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUESTS_LIST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                errorMessage: null,
                loadingEntity: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_REPLACEMENT_REQUEST):
        case REQUEST(ACTION_TYPES.APPROVE_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUESTS_LIST):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                loadingEntity: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.CREATE_CARD_REPLACEMENT_REQUEST):
        case FAILURE(ACTION_TYPES.APPROVE_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUESTS_LIST): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list,
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                loadingEntity: false,
                entity: action.payload.data,
            };
        case SUCCESS(ACTION_TYPES.CREATE_CARD_REPLACEMENT_REQUEST):
        case SUCCESS(ACTION_TYPES.APPROVE_CARD_REPLACEMENT_REQUEST):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
                loadingEntity: false,
            };
        case ACTION_TYPES.CLEAR_MUTATION_FLAGS:
            return {
                ...state,
                updateSuccess: false,
                updating: false,
                errorMessage: null,
            };
        case ACTION_TYPES.RESET:
            return { ...initialState };
        default:
            return state;
    }
};
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUESTS_LIST,
    payload: cmsHttp().get(apiUrl, params === undefined
        ? undefined
        : {
            params: buildSpringPageParams(params),
            paramsSerializer: { indexes: null },
        }),
});
export const getEntitiesByOldCardId = (cardId, params) => {
    const id = typeof cardId === 'string' ? Number(cardId) : cardId;
    return getEntities({
        ...(params ?? {}),
        'oldCardId.equals': id,
    });
};
export const getEntity = (id) => ({
    type: ACTION_TYPES.FETCH_CARD_REPLACEMENT_REQUEST,
    payload: cmsHttp().get(`${apiUrl}/${id}`),
});
export const createEntity = (body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.CREATE_CARD_REPLACEMENT_REQUEST,
    payload: cmsHttp().post(`${apiUrl}/minimal`, body),
});
export const approveRequest = (id, body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.APPROVE_CARD_REPLACEMENT_REQUEST,
    payload: cmsHttp().post(`${apiUrl}/${id}/approve`, body),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
export const clearMutationFlags = () => ({
    type: ACTION_TYPES.CLEAR_MUTATION_FLAGS,
});
